// extracted by mini-css-extract-plugin
export default {"tupacGrid":"an-z","tupacHeader":"bn-z","tupacHeader2":"cn-z","tupacMenu":"dn-z","tupacMenu2":"en-z","tupacMain":"fn-z","tupacMain2":"gn-z"};